export const statusObj = {
    Init: 'info',
    Running: 'primary',
    Completed: 'success',
    Cancelled: 'warning',
    Failed: 'error'
}